import fetch from './fetch';

const getRegRateStatistics = params => fetch({ url: '/registration_rate_statistics', params });
const getBackStudyRateStatistics = params => fetch({ url: '/back_study_rate_statistics', params });
const getBackStudyStatistics = params => fetch({ url: '/back_study_rate_specialized_subject_statistics', params });
const rockingRateStatistics = params => fetch({ url: '/rocking_success_rate_statistics', params });
const exportRockingRateStatistics = ({ params }) => fetch({
  url: '/export_rocking_rate_statistics',
  params,
  isFull: true,
  config: { responseType: 'blob' }
});
const classroomDetail = params => fetch({ url: '/classroom_detail', params });
const roomStatisticsRoom = params => fetch({ url: '/classroom_statistics_by_classroom', params });
const roomStatisticsQuarter = params => fetch({ url: '/classroom_statistics_by_quarter', params });

const exportBackRate = ({ params }) => fetch({
  url: '/export_back_study_rate_statistics',
  params,
  isFull: true,
  config: { responseType: 'blob' }
});
const exportBackStudyRate = ({ params }) => fetch({
  url: '/export_back_study_rate_specialized_subject_statistics',
  params,
  isFull: true,
  config: { responseType: 'blob' }
});
const exportRegistrationRate = ({ params }) => fetch({
  url: '/export_registration_rate_statistics',
  params,
  isFull: true,
  config: { responseType: 'blob' }
});

const getClassSignUpStatistics = params => fetch({ url: '/class_sign_up_statistics', params });
const getClassSignUpTotal = params => fetch({ url: '/get_class_sign_up_statistics_total', params });
const getAdmissionStatistics = params => fetch({ url: '/recruit_situation_statistics', params });
const getTrainingStatistics = params => fetch({ url: '/teacher_training_statistics', params });

export default {
  exportRegistrationRate,
  exportBackStudyRate,
  roomStatisticsRoom,
  classroomDetail,
  getRegRateStatistics,
  getBackStudyRateStatistics,
  rockingRateStatistics,
  exportRockingRateStatistics,
  roomStatisticsQuarter,
  getClassSignUpStatistics,
  getClassSignUpTotal,
  getAdmissionStatistics,
  getTrainingStatistics,
  getBackStudyStatistics,
  exportBackRate
};
